import { Errors } from 'constants/copy/inputs'

export const INPUT_ERRORS_COPY: CopyRecord<Errors> = {
  [Errors.required]: 'Wajib diisi',
}
